import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 228px;
  width: 100%;
  border: 1px solid ${({ isActive }) => isActive ? '#FED130' : COLORS.grey};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;

  @media (max-width: 1023px) {
    max-width: 100%;
  }

  :before {
    content: ${({ isActive }) => isActive ? 'url(\'/static/images/icons/check-yellow.svg\')' : ''};
    position: absolute;
    width: 12px;
    height: 12px;
    top: 16px;
    right: 12px;
  }
`;

export const Title = styled.div`
  ${FONTS.M};
  font-size: 16px;
  line-height: 1.25;
`;

export const Price = styled.div`
  ${FONTS.M};
  font-size: 12px;
  line-height: 1.333;
  padding-top: 8px;
  padding-bottom: 9px;
  width: 100%;
  border-bottom: 1px solid ${COLORS.outlineGrey};
`;

export const Description = styled.div`
  ${FONTS.XXS};
  font-size: 12px;
  line-height: 1.333;
  margin-top: 8px;
  color: ${COLORS.darkGrey};
`;
